var address = {};
module['exports'] = address;
address.default_country = require("./default_country");
address.postcode_by_state = require("./postcode_by_state");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_US/address/index.js
// module id = 2181
// module chunks = 2